import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LinkDropdown from "../dropdown/LinkDropDown";

interface Link {
  id:number;
  name: string;
  to: string;
  description: string;
}

const developerLinks: Link[] = [
  { 
    id:1,
    name: "Documentation",
    to: "https://spay.readme.io/docs",
    description: "Developer documentation for Spay.",
  },
  {
    id:2,
    name: "Api Status",
    to: "/api-status",
    description: "API reference for Spay developers.",
  },
];

const resourceLinks: Link[] = [
  {
    id:1,
    name: "Jobs",
    to: "/jobs",
    description: "Explore our array of job openings.",
  },
  {
    id:2,
    name: "Guide",
    to: "/guide",
    description: "Read our intuitive guide.",
  },
];

const productLinks: Link[] = [
  {
    id:1,
    name: "Swop",
    to: "/swop",
    description: "Explore our array of job openings.",
  },
  {
    id:2,
    name: "Payment Link",
    to: "/payment-link",
    description: "Read our intuitive guide.",
  },
  {
    id:3,
    name: "Invoice",
    to: "/invoice",
    description: "Read our intuitive guide.",
  },
  {
    id:4,
    name: "Direct debit",
    to: "/direct-debit",
    description: "Read our intuitive guide.",
  },
  {
    id:4,
    name: "Checkout",
    to: "/checkout",
    description: "Read our intuitive guide.",
  },
];

const isSidebar = true;

export default function AccordionUsage() {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{
          marginBottom: 2,
        
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          Products
        </AccordionSummary>
        <AccordionDetails>
          <LinkDropdown links={productLinks} isSidebar={isSidebar} />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={{
          marginBottom: 2,
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          Resources
        </AccordionSummary>
        <AccordionDetails>
          <LinkDropdown links={resourceLinks} isSidebar={isSidebar} />
     
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        sx={{
          marginBottom: 2,
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          Developers
        </AccordionSummary>
        <AccordionDetails>
          <LinkDropdown links={developerLinks} isSidebar={isSidebar} />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
